var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import { stateCallback, propsCallback } from "./blueprint";
import resolveValue from "./utils/resolveValue";
export function withState(stateName, updaterName, initialValue) {
  return {
    instanceCallbacks: function instanceCallbacks() {
      var update;
      var name;
      return [stateCallback(function (initState, props) {
        var newState = initState(String(stateName), resolveValue(initialValue, props));
        update = newState.updater;
        name = newState.name;
      }), propsCallback(function (props, state) {
        return __assign({}, props, (_a = {}, _a[stateName] = state[name], _a[updaterName] = update, _a));

        var _a;
      })];
    }
  };
}
export default withState;